import type { ClassNameProp } from "@charterindex/armoury-www";
import { css, styled } from "@mui/material/styles";
import { DateRangeIcon, DateRangePicker } from "@mui/x-date-pickers-pro";
import { add } from "date-fns";
import { useSubject } from "ecce-react";
import useTranslation from "next-translate/useTranslation";
import { useEnquiryController } from "../../enquiry-controller-context";


const EnquiryFormDatesFieldRoot = styled("div")(({ theme }) => css`
	display: flex;
	align-items: center;
	gap: ${theme.spacing(1)};
	
	.picker {
		flex: 1;
	}
`);
export const EnquiryFormDatesField = ({ className }: ClassNameProp) => {
	const controller = useEnquiryController();
	useSubject(controller.model, "dates");
	useSubject(controller, "submitting");

	const { t } = useTranslation();

	return (
		<EnquiryFormDatesFieldRoot className={ className }>
			<DateRangeIcon/>
			<DateRangePicker
				className="picker"
				value={ controller.model.dates }
				onChange={ value => controller.model.dates = value }
				minDate={ add(Date.now(), { days: 1 }) }
				localeText={{
					start: t("common:start-date"),
					end: t("common:end-date"),
				}}
				slotProps={{
					fieldSeparator: {
						sx: { display: "none" },
					},
					textField: {
						size: "small",
					},
				}}
			/>
		</EnquiryFormDatesFieldRoot>
	);
};
